import React from 'react'
import { Route, Redirect } from 'react-router'
import Loadable from 'react-loadable'
import loading from 'components/ui/Loader/Loader'

const LoadContainer = Loadable({ loader: () => import('containers/LoadContainer/LoadContainer'), loading })
const DashboardPage = Loadable({ loader: () => import('layers/dashboard/pages/DashboardPage/DashboardPage'), loading })
const StatisticPage = Loadable({ loader: () => import('layers/dashboard/pages/StatisticPage/StatisticPage'), loading })


export default (links) => (
  <Route component={LoadContainer}>
    <Route path={links.root} component={DashboardPage} />
    <Route path={links.statistic} component={StatisticPage} />

    <Redirect path={`${links.root}/*`} to={links.root} />
  </Route>
)
